import CirclePercentage from "../CirclePercentage";
export default function PercentageText(params) {
  var _params$otherFields;
  const {
    value,
    innerMethods,
    data
  } = params;
  const percentage = params.data[(_params$otherFields = params.otherFields) === null || _params$otherFields === void 0 ? void 0 : _params$otherFields.percentage];
  if (!value || isNaN(parseInt(percentage, 10))) return null;
  const percentageText = document.createElement('div');
  percentageText.classList.add('w5-percentage-text-cell');
  const circle = CirclePercentage(percentage, params);
  if (!circle) return null;
  const textContainer = document.createElement('div');
  textContainer.classList.add('w5-percentage-text-cell__text');
  if (innerMethods !== null && innerMethods !== void 0 && innerMethods.getUrl && !params.onClick) {
    const linkElement = document.createElement('a');
    linkElement.href = innerMethods.getUrl(data);
    linkElement.innerText = value;
    textContainer.appendChild(linkElement);
  } else textContainer.innerText = value;

  // const text = document.createElement('div');
  // text.classList.add('w5-percentage-text-cell__text');
  // text.innerHTML = value;

  percentageText.appendChild(circle);
  percentageText.appendChild(textContainer);
  return percentageText;
}